import React from 'react'


function Loader(){
  return(
    <div style={{position: 'fixed', top: '0', width: '100%', height: '100vh', display: 'flex', justifyContent: 'center', alignItems: 'center', margin: '.5rem',zIndex:9999 }}>
      <div className='lds-dual-ring' />
    </div>
  )
}
export default Loader
